import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { BRAND, NAV_LINKS } from "../data/content";
import { Wordmark } from "./Wordmark";

const LEGAL_LINKS = [
  { label: "Mentions légales", to: "/mentions-legales" },
  { label: "Politique de confidentialité", to: "/politique-de-confidentialite" },
  { label: "CGV", to: "/cgv" },
  { label: "Politique de cookies", to: "/politique-de-cookies" },
];

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#150E1C]" data-testid="footer">
    <div className="mx-auto grid max-w-[1500px] gap-12 px-6 py-16 sm:px-10 lg:grid-cols-12 lg:px-16">
      <div className="lg:col-span-6">
        <Wordmark size="lg" />
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/50">{BRAND.baseline}</p>
        <a
          href={BRAND.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          aria-label="Instagram Demoiselle Atypique"
          className="mt-6 inline-flex h-11 w-11 items-center justify-center border border-white/20 text-white/70 transition-colors hover:border-neon hover:text-neon"
        >
          <Instagram className="h-4 w-4" />
        </a>
      </div>
      <div className="lg:col-span-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">Navigation</p>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.label}>
              {l.to.includes("#") ? (
                <Link to={l.to.split("#")[0] || "/"} state={{ scrollTo: l.to.split("#")[1] }} className="text-sm text-white/60 transition-colors hover:text-cream">
                  {l.label}
                </Link>
              ) : (
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-white/60 transition-colors hover:text-cream">
                  {l.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">Informations</p>
        <ul className="mt-5 space-y-3">
          <li>
            <Link to="/rendez-vous" data-testid="footer-link-contact" className="text-sm text-white/60 transition-colors hover:text-cream">
              Contact
            </Link>
          </li>
          {LEGAL_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-link-${l.to.slice(1)}`} className="text-sm text-white/60 transition-colors hover:text-cream">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-[1500px] flex-col gap-4 px-6 py-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between sm:px-10 lg:px-16">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Demoiselle Atypique — SAS DEMOISELLE ATYPIQUE. Tous droits réservés.</p>
        <nav className="flex flex-wrap items-center gap-x-3 gap-y-2" aria-label="Liens légaux" data-testid="footer-legal-nav">
          {LEGAL_LINKS.filter((l) => l.to !== "/cgv").map((l, i) => (
            <span key={l.to} className="flex items-center gap-3">
              {i > 0 && <span className="text-white/20">|</span>}
              <Link to={l.to} data-testid={`footer-legal-${l.to.slice(1)}`} className="transition-colors hover:text-cream">
                {l.label}
              </Link>
            </span>
          ))}
        </nav>
      </div>
    </div>
  </footer>
);
